import { AxiosHttpClient } from 'infra/http/axios-http-client/axios-http-client';

import { AuthorizeHttpClientDecorator } from '../../decorators/authorize-http-client-decorator';
import { makeSessionStorage } from './session-storage-factory';

export const makeAxiosHttpClient = (): AxiosHttpClient => {
  return new AuthorizeHttpClientDecorator(
    makeSessionStorage(),
    new AxiosHttpClient(),
  );
};
